<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <h1>Renda Adicional</h1>
      <p>Você possui outra fonte de renda?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group">
            <input class="form-control form-control-lg" v-model="extra" id="extra" type="text" placeholder="R$" required v-mask="'money'"/>
          </div>
          <div class="form-check d-flex justify-content-center">
            <div class="checkboxContainer">
              <input type="checkbox" class="form-check-input" id="noOther" @click="noHaveOther">
              <span class="checkmark"></span>
            </div>
            <label class="form-check-label" for="noOther">Não possuo outra fonte de renda!</label>
          </div>
          <div class="text-center fixedOptions">
            <button :disabled="RendaValida" class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .options,
  form {
    padding-top: 1rem;
  }

  .form-check {
    padding-bottom: 1rem;
  }
</style>


<script>
import Masker from '@/utils/masker'

export default {
  data() {
    const social = this.currentUser.Social
    return {
      hasOtherIncomeSources: true,
      extra: (social && social.ValorOutraFonteRenda) ? social.ValorOutraFonteRenda.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null
    }
  },
  computed: {
    RendaValida: function() { return parseFloat(this.extra) <= 0 }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    noHaveOther() {
      if(document.getElementById("noOther").checked) {
        document.getElementById("extra").removeAttribute("required", "");
        this.hasOtherIncomeSources = false
      } else {
        document.getElementById("extra").setAttribute("required", "");
        this.hasOtherIncomeSources = true
      }
      
    },
    onSubmit(e) {
      e.preventDefault()

      if(this.hasOtherIncomeSources) {
        this.currentUser.Social.OutraFonteRenda = true;
        this.currentUser.Social.ValorOutraFonteRenda = Number.parseFloat(Masker.unmaskMoney(this.extra))
      } else {
        this.currentUser.Social.OutraFonteRenda = false;
        this.currentUser.Social.ValorOutraFonteRenda = 0.0
      }

      this.$emit('on-submit', {Social: this.currentUser.Social})
    }
  },
  mounted() {
    if(!this.currentUser.Social.OutraFonteRenda) {
      document.getElementById('noOther').click();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/RendaExtraStep.vue